import _ from 'lodash';

export default {
  SET_DNT_LIST(state, payload) {
    // TODO: test clean the list state before.
    state.list = (payload.documentos || [])
      .map((option) => ({
        ...option,
        enviadoOpenText: option.enviadoOpenText || 'N'
      }))
      .reduce((index, option) => ({
        ...index,
        [option.febosId]: option
      }), {});
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LOADING_BINNACLE(state, payload) {
    state.loadingBinnacle = payload;
  },
  SET_DETAIL_FILE(state, payload) {
    state.details = payload;
  },
  UPDATE_CANCELED_DNT(state, payload) {
    state.list[payload.febosId].estado = 8;
  },
  UPDATE_DELETED_DRAFT_DNT(state, payload) {
    const { [payload.febosId]: ignored, ...cleanStateDnt } = state.list;
    state.list = cleanStateDnt;
  },
  UPDATE_PROCESSED_DNT(state, payload) {
    state.list[payload.febosId].estado = 9;
    state.list[payload.febosId].transportePuertoTipo = '0';
  },
  UPDATE_CONTROLLED_DNT(state, payload) {
    state.list[payload.febosId].estado = '70';
  },
  UPDATE_ARCHIVED_DNT(state, payload) {
    state.list[payload.febosId].estado = '100';
  },
  UPDATE_ASIGNED_FILE(state, febosId) {
    state.list[febosId].enGrupo = 'NO';
  },
  UPDATE_SEND_TO_DOCDIGITAL(state, febosId) {
    const { [febosId]: ignored, ...cleanStateDnt } = state.list;
    state.list = cleanStateDnt;
  },
  UPDATE_FILE(state, { febosId, metadata }) {
    state.list[febosId].enviadoOpenText = metadata.valor;
  },
  UPDATE_SENT_FILE(state, febosId) {
    const { [febosId]: ignored, ...cleanStateDnt } = state.list;
    state.list = cleanStateDnt;
  },
  SET_WIZARD_DATA(state, payload) {
    state.wizardData = payload;
  },
  SET_WIZARD_STORAGE(state, file) {
    state.wizardStorage = file;
  },
  ADD_WIZARD_DATA(state, payload) {
    state.wizardData = {
      ...state.wizardData,
      ...payload
    };
  },
  MERGE_WIZARD_DATA(state, payload) {
    state.wizardData = _.merge(state.wizardData, payload);
  },
  CLEAR_WIZARD_DATA(state) {
    state.wizardData = {};
  },
  CLEAR_DETAILS(state) {
    state.details = {
      comentarios: [],
      cuerpo: '',
      adjuntos: []
    };
  },
  SET_DETAIL_DNT(state, payload) {
    state.details = payload;
  },
  SET_ATTACHMENTS_DNT(state, payload) {
    state.attachments = payload;
  },
  SET_SUCCESS_MESSAGE(state, payload) {
    state.successAction = payload;
  },
  SET_ERROR_MESSAGE(state, payload) {
    state.error = payload;
  },
  CLOSE_MODAL(state, payload) {
    state.showModal = payload;
  },
  SET_COMMENTS(state, payload) {
    state.comments = payload;
  },
  ADD_COMMENT(state, payload) {
    // add comment to array in state
    state.comments = state.comments.concat(payload);
  },
  SET_BINNACLE(state, payload) {
    state.binnacle = payload;
  },
  SET_TIMELINE(state, payload) {
    state.timeline = payload;
  },
  SET_ACTIVITIES_FILE(state, payload) {
    state.activities = payload;
  },
  SET_ACTIVITIES_TIMELINE_FILE(state, payload) {
    state.activitiesHistory = payload;
  },
  SET_REFERENCES_DNT(state, payload) {
    state.references = payload.referenciadosTipoDnt
      .concat(payload.referenciadosTipoDte, payload.referenciasTipoDnt, payload.referenciasTipoDte);
    const referenciadosTipoDnt = payload.referenciadosTipoDnt.map((reference) => ({
      ...reference,
      type: 'referenciadosTipoDnt'
    }));
    const referenciadosTipoDte = payload.referenciadosTipoDte.map((reference) => ({
      ...reference,
      type: 'referenciadosTipoDte'
    }));
    const referenciasTipoDnt = payload.referenciasTipoDnt.map((reference) => ({
      ...reference,
      type: 'referenciasTipoDnt'
    }));
    const referenciasTipoDte = payload.referenciasTipoDte.map((reference) => ({
      ...reference,
      type: 'referenciasTipoDte'
    }));
    const referencesByType = referenciadosTipoDnt
      .concat(referenciadosTipoDte, referenciasTipoDnt, referenciasTipoDte);
    state.referencesByType = referencesByType;
  },
  CLEAR_REFERENCES(state) {
    state.references = [];
  },
  SET_SELECTED_FILE(state, payload) {
    state.selectedFile = payload;
  },
  UPDATE_SUBJECTS_FILE(state, payload) {
    state.details.destinatarios = payload;
  },
  LOADING_DOCS(state, payload) {
    state.loadingDocs = payload;
  },
  SET_COMMUNES(state, payload) {
    state.communes = payload.map((commune) => ({
      ...commune,
      id: commune.codigo,
      label: `(${commune.codigo}) ${commune.nombre}`
    }));
  },
  FORM_SELECTED_DOCUMENT(state, document) {
    state.documentTypeSelected = document;
  },
  DOCUMENTS_OPTIONS(state, options) {
    state.documentsOptions = options;
  }
};
